import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

function LandingPage() {
    const [isShareLinkClicked, setIsShareLinkClicked] = useState(false);   
    const [isUploadLinkClicked, setIsUploadLinkClicked] = useState(false);   
    
    let ShareAppUrl = process.env.REACT_APP_SHARE_APP_URL;

    const handleAccessShareClick = (event) => {
        event.preventDefault(); // Prevent default navigation
        setIsShareLinkClicked((prevState) => !prevState); // Toggle the visibility state
        setIsUploadLinkClicked(false);
    };
    const handleAccessUploadClick = (event) => {
        event.preventDefault(); // Prevent default navigation
        setIsUploadLinkClicked((prevState) => !prevState); // Toggle the visibility state
        setIsShareLinkClicked(false);
    };
    let navigate = useNavigate();
    async function handleClick(event) {
        event.preventDefault();
        navigate("/Appointment/Create");
    }
    let orgName = localStorage.getItem("orgName");
    //let AccessToken = localStorage.getItem("AccessToken")

    let userName = ''
    if (localStorage.getItem("AccessToken") != null) {
        const decoded = jwt_decode(localStorage.getItem("AccessToken"));
        userName = decoded.name;
    } else {
        userName = "Care IO"
    }
    //console.log(AccessToken);


    const redirectToShareLink = () => {
        window.open(ShareAppUrl + '/share', '_blank', 'noopener,noreferrer')
    };

    const redirectToUploadLink = () => {
        window.open(ShareAppUrl + '/uploader', '_blank', 'noopener,noreferrer')
    };

    const { instance } = useMsal();

    return (
        <div className="col-md-12">
            <div className="row justify-content-md-center">
                <AuthenticatedTemplate>
                    <div className="text-center">
                        <h2 className="mt-5 mb-5">Welcome <span className="hyperlink">{userName}</span></h2>
                    </div>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <div className="text-center">
                        <h2 className="mt-5 mb-5">Welcome to <span className="hyperlink">CareIO</span></h2>
                    </div>
                </UnauthenticatedTemplate>

                <div className="col col-lg-8">
                    <div className="row row-cols-4 justify-content-center">
                        <AuthenticatedTemplate>
                            <div className="col text-center">
                                <div className="boxview">
                                    <i className="dashboard-icn"></i>
                                    <h4 className="mt-2 mb-1">Dashboard</h4>
                                    <p className="secondary-info">See my info in one view</p>
                                    <a href="/dashboard" className="hyperlink text-decoration-none disabled">Go to Dashboard <i className="fa fa-chevron-right"></i></a>
                                </div>
                            </div>
                        </AuthenticatedTemplate>
                        <div className="col text-center d-none">
                            <div className="boxview">
                                <i className="book-icn"></i>
                                <h4 className="mt-2 mb-1">Book an Appointment</h4>
                                <p className="secondary-info">Book your appointment now!</p>
                                <a onClick={handleClick} href="/Appointment/Step1" className="hyperlink text-decoration-none">Book Now <i className="fa fa-chevron-right"></i></a>
                                <AuthenticatedTemplate>
                                    &nbsp; | &nbsp;
                                    <a href="/Appointment" className="hyperlink text-decoration-none">Appointments <i className="fa fa-chevron-right"></i></a>
                                </AuthenticatedTemplate>
                            </div>
                        </div>
                        <AuthenticatedTemplate>
                            <div className="col text-center">
                                <div className="boxview">
                                    <i className="studies-icn"></i>
                                    <h4 className="mt-2 mb-1">Imaging Studies</h4>
                                    <p className="secondary-info">See my Imaging Studies</p>
                                    <a href="/imagingstudy" className="hyperlink text-decoration-none">Click here <i className="fa fa-chevron-right"></i></a>
                                </div>
                            </div>
                            <div className="col text-center">
                                <div className="boxview">
                                    <i className="report-icn"></i>
                                    <h4 className="mt-2 mb-1">Diagnostic Reports</h4>
                                    <p className="secondary-info">See my Diagnostic Reports</p>
                                    <a href="/diagnosticreport" className="hyperlink text-decoration-none">Click here <i className="fa fa-chevron-right"></i></a>
                                </div>
                            </div>
                        </AuthenticatedTemplate>

                        <UnauthenticatedTemplate>
                            <div className="col text-center">
                                <div className="boxview">
                                    <i className="share-icn"></i>
                                    <h4 className="mt-2 mb-1">Access Records</h4>
                                    <p className="secondary-info">Access your records with a share code <br></br> or share link</p>
                                    <a className="hyperlink text-decoration-none" onClick={handleAccessShareClick}> Click here <i className="fa fa-chevron-right"></i> </a>
                                </div>
                            </div>
                            <div className="col text-center">
                                <div className="boxview">
                                    <i className="upload-icn"></i>
                                    <h4 className="mt-2 mb-1">Upload Records</h4>
                                    <p className="secondary-info">Upload documents with a share code <br></br> or upload link</p>
                                    <a href="javacript:void(0)" className="hyperlink text-decoration-none" onClick={handleAccessUploadClick}>Click here <i className="fa fa-chevron-right"></i></a>
                                </div>
                            </div>
                            <div className="col text-center">
                                <div className="boxview">
                                    <i className="register-icn"></i>
                                    <h4 className="mt-2 mb-1">Find Records</h4>
                                    <p className="secondary-info">Click to find my health records</p>
                                    <a className="hyperlink text-decoration-none" href="/find" onClick={(e) => { e.preventDefault(); navigate("/find", { state: { formType: "shareCode" } }); }} >
                                        Click here <i className="fa fa-chevron-right"></i>
                                    </a>
                                </div>
                            </div>
                        </UnauthenticatedTemplate>

                    </div>
                </div>
                {/* Conditionally render the SharePage component */}
                {isShareLinkClicked && (
                    <div className="row justify-content-md-center mt-3">
                        <div className="col col-lg-5 arrow_box left-arrow">
                            <div className="row justify-content-center">
                                <div className="col text-center">
                                    <div className="boxview">
                                        <i className="sharecode-icn"></i>
                                        <h4 className="mt-2 mb-1">Share Code</h4>
                                        <p>Verify the share code and upload the records</p>
                                        <a className="hyperlink text-decoration-none" onClick={redirectToShareLink} >
                                            Click here <i className="fa fa-chevron-right"></i>
                                        </a>
                                    </div>
                                </div>

                                <div className="col text-center">
                                    <div className="boxview">
                                        <i className="link-icn"></i>
                                        <h4 className="mt-2 mb-1">Share Link</h4>
                                        <p>Check your email and click the link. <br />Don't have the link? Please contact your provider </p>
                                        {/* <a className="hyperlink text-decoration-none" onClick={(e) => { e.preventDefault(); navigate("/share", { state: { formType: "shareLink" } }); }} >
                                            I have the link <i className="fa fa-chevron-right"></i>
                                        </a> */}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                )}

                {isUploadLinkClicked && (
                    <div className="row justify-content-md-center mt-3">
                        <div className="col col-lg-5 arrow_box">
                            <div className="row justify-content-center">
                                <div className="col text-center">
                                    <div className="boxview">
                                        <i className="sharecode-icn"></i>
                                        <h4 className="mt-2 mb-1">Share Code</h4>
                                        <p>Verify the share code and upload the records</p>
                                        <a className="hyperlink text-decoration-none" onClick={redirectToUploadLink}>
                                            Click here <i className="fa fa-chevron-right"></i>
                                        </a>
                                    </div>
                                </div>

                                <div className="col text-center">
                                    <div className="boxview">
                                        <i className="link-icn"></i>
                                        <h4 className="mt-2 mb-1">Upload Link</h4>
                                        <p>Check your email and click the link. <br />Don't have the link? Please contact your provider </p>
                                        {/* <a className="hyperlink text-decoration-none" onClick={(e) => { e.preventDefault(); navigate("/share", { state: { formType: "shareLink" } }); }} >
                                            I have the link <i className="fa fa-chevron-right"></i>
                                        </a> */}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default LandingPage;